import React, {
  useEffect,
  useState,
} from "react";

import {
  Link,
  NavLink,
  useNavigate,
} from "react-router-dom";

import DonationModal from "../pages/DonationModal";

import {
  getLinkedClubsApi,
} from "../api/ClientActions";

const API_URL = (
  process.env.REACT_APP_API_URL ||
  "https://api.bsangam.com"
)
  .replace(/\/uploads\/?$/, "")
  .replace(/\/$/, "");

// ==========================
// UPLOAD URL HELPER
// ==========================
const getUploadUrl = (
  file?: string | null
) => {
  if (
    !file ||
    String(file).trim() === ""
  ) {
    return "/assets/images/user.png";
  }

  const value =
    String(file).trim();

  // Already full URL
  if (
    value.startsWith("http://") ||
    value.startsWith("https://")
  ) {
    return encodeURI(value);
  }

  // /uploads/filename.jpg
  if (
    value.startsWith("/uploads/")
  ) {
    return encodeURI(
      `${API_URL}${value}`
    );
  }

  // uploads/filename.jpg
  if (
    value.startsWith("uploads/")
  ) {
    return encodeURI(
      `${API_URL}/${value}`
    );
  }

  // /other/path/file.jpg
  if (value.startsWith("/")) {
    return encodeURI(
      `${API_URL}${value}`
    );
  }

  // filename.jpg
  return encodeURI(
    `${API_URL}/uploads/${value}`
  );
};

const Header: React.FC = () => {
  const navigate =
    useNavigate();

  const [
    showDonate,
    setShowDonate,
  ] = useState(false);

  const [
    currentUser,
    setCurrentUser,
  ] = useState<any>(() =>
    JSON.parse(
      localStorage.getItem("user") ||
        "{}"
    )
  );

  const [
    linkedClubs,
    setLinkedClubs,
  ] = useState<any[]>([]);

  const savedClient =
    JSON.parse(
      localStorage.getItem("client") ||
        "{}"
    );

  const selectedClient =
    JSON.parse(
      localStorage.getItem(
        "selectedClient"
      ) || "null"
    );

  const isLoggedIn =
    Boolean(
      currentUser?.user_id
    );

  const clientId =
    Number(
      savedClient?.client_id ||
        selectedClient?.client_id ||
        0
    );

  const contactId =
    Number(
      savedClient?.contact_id ||
        savedClient?.client_user_id ||
        0
    );

  // ==========================
  // DISPLAY NAME
  // ==========================
  const displayName =
    isLoggedIn
      ? currentUser?.user_fullname ||
        currentUser?.full_name ||
        currentUser?.name ||
        "User"
      : "Welcome Guest";

  // ==========================
  // PROFILE PHOTO
  // ==========================
  const profilePhoto =
    isLoggedIn
      ? getUploadUrl(
          currentUser?.profile_photo
        )
      : "/assets/images/user.png";

  // ==========================
  // PROFILE ROLE
  // ==========================
  const profileRole =
    isLoggedIn
      ? currentUser?.email ||
        currentUser?.user_email ||
        currentUser?.phone_number ||
        "Logged User"
      : selectedClient?.client_name
      ? `Viewing ${selectedClient.client_name}`
      : "Login to join clubs and interact";

  // ==========================
  // PROFILE LOCATION / DOB
  // ==========================
  const profileLocation =
    isLoggedIn
      ? currentUser?.dob
        ? new Date(
            currentUser.dob
          ).toLocaleDateString(
            "en-IN",
            {
              day: "numeric",
              month: "short",
              year: "numeric",
            }
          )
        : currentUser?.date_of_birth
        ? new Date(
            currentUser.date_of_birth
          ).toLocaleDateString(
            "en-IN",
            {
              day: "numeric",
              month: "short",
              year: "numeric",
            }
          )
        : ""
      : "Guest Mode";

  // ==========================
  // UI STATE
  // ==========================
  const [
    uiState,
    setUiState,
  ] = useState({
    isOpen: false,
    isNoti: false,
  });

  const toggleState = (
    key: keyof typeof uiState
  ) => {
    setUiState(
      (prev) => ({
        ...prev,
        [key]: !prev[key],
      })
    );
  };

  const closeMobileMenu = () => {
    setUiState(
      (prev) => ({
        ...prev,
        isOpen: false,
      })
    );
  };

  const navClass =
    uiState.isOpen
      ? "nav-active"
      : "";

  const buttonClass =
    uiState.isOpen
      ? "active"
      : "";

  const notiClass =
    uiState.isNoti
      ? "show"
      : "";

  // ==========================
  // LOAD LINKED CLUBS
  // ==========================
  const loadLinkedClubs =
    async () => {
      if (
        !currentUser?.user_id
      ) {
        setLinkedClubs([]);
        return;
      }

      try {
        const result =
          await getLinkedClubsApi(
            currentUser.user_id
          );

        if (
          result?.success ===
            false ||
          result?.status ===
            false
        ) {
          setLinkedClubs([]);
          return;
        }

        setLinkedClubs(
          Array.isArray(
            result?.data
          )
            ? result.data
            : Array.isArray(
                result?.clients
              )
            ? result.clients
            : []
        );
      } catch (error) {
        console.error(
          "Joined clubs fetch error:",
          error
        );

        setLinkedClubs([]);
      }
    };

  // ==========================
  // LOAD LINKED CLUBS
  // ==========================
  useEffect(() => {
    loadLinkedClubs();
  }, [
    currentUser?.user_id,
  ]);

  // ==========================
  // REFRESH USER WHEN PROFILE CHANGES
  // ==========================
  useEffect(() => {
    const refreshUser = () => {
      setCurrentUser(
        JSON.parse(
          localStorage.getItem(
            "user"
          ) || "{}"
        )
      );
    };

    window.addEventListener(
      "userProfileUpdated",
      refreshUser
    );

    window.addEventListener(
      "storage",
      refreshUser
    );

    return () => {
      window.removeEventListener(
        "userProfileUpdated",
        refreshUser
      );

      window.removeEventListener(
        "storage",
        refreshUser
      );
    };
  }, []);

  return (
    <>
      <style>
        {`
          html,
          body {
            margin: 0 !important;
            padding: 0 !important;
            border: 0 !important;
            outline: 0 !important;
          }

          .nav-header {
            height: 86px !important;
            min-height: 86px !important;
            padding: 0 !important;
            margin: 0 !important;
            border: 0 !important;
            border-bottom: 1px solid #eef3fb !important;
            box-shadow: 0 8px 28px rgba(15, 23, 42, 0.035) !important;
            outline: 0 !important;
            background: rgba(255, 255, 255, 0.96) !important;
            backdrop-filter: blur(14px);
          }

          .nav-header::before,
          .nav-header::after {
            display: none !important;
            content: none !important;
          }

          .nav-top {
            height: 86px !important;
            min-height: 86px !important;
            padding: 0 18px !important;
            margin: 0 !important;
            display: flex !important;
            align-items: center !important;
          }

          .navigation {
            top: 86px !important;
            height: calc(100vh - 86px) !important;
            overflow-y: auto !important;
            overflow-x: hidden !important;
            background: transparent !important;
            padding-top: 0 !important;
            margin-top: 0 !important;
          }

          .navigation::-webkit-scrollbar {
            width: 4px;
          }

          .navigation::-webkit-scrollbar-thumb {
            background: #cbd5e1;
            border-radius: 20px;
          }

          .logo-wrapper {
            display: inline-flex;
            align-items: center;
          }

          .main-logo {
            width: 118px;
            height: auto;
            object-fit: contain;
          }

          .center-menu-icon {
            width: 54px !important;
            height: 64px !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            position: relative !important;
            border-radius: 0 !important;
            background: transparent !important;
            text-decoration: none !important;
          }

          .center-menu-icon::after {
            content: "";
            position: absolute;
            left: 50%;
            bottom: 4px;
            width: 0;
            height: 3px;
            border-radius: 999px;
            background: #0d8bff;
            transform: translateX(-50%);
            transition: 0.25s ease;
          }

          .center-menu-icon.active::after {
            width: 24px;
          }

          .center-menu-icon.bs-heart-link::after {
            background: #e11d48;
          }

          .center-menu-icon i,
          .mob-menu i {
            background: transparent !important;
            box-shadow: none !important;
            transition: 0.25s ease;
          }

          .center-menu-icon i {
            color: #8a97aa !important;
          }

          .center-menu-icon:hover i,
          .center-menu-icon.active i {
            background: transparent !important;
            color: #0d8bff !important;
            transform: translateY(-2px) scale(1.16);
            filter: drop-shadow(
              0 7px 9px
              rgba(13, 139, 255, 0.25)
            );
          }

          .center-menu-icon i.text-danger {
            background: transparent !important;
            color: #e11d48 !important;
          }

          .center-menu-icon:hover i.text-danger,
          .center-menu-icon.active i.text-danger {
            background: transparent !important;
            color: #e11d48 !important;
            transform: translateY(-2px) scale(1.16);
            filter: drop-shadow(
              0 7px 9px
              rgba(225, 29, 72, 0.25)
            );
          }

          .mob-menu:hover i {
            background: transparent !important;
            color: #0d8bff !important;
            transform: scale(1.15);
            filter: drop-shadow(
              0 6px 8px
              rgba(13, 139, 255, 0.25)
            );
          }

          .top-avatar-link {
            width: 44px;
            height: 44px;
            border-radius: 50%;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            position: relative;
          }

          .nav-content {
            padding: 8px 8px 18px;
          }

          .bs-profile-card {
            background: #ffffff;
            border: 1px solid #edf2f7;
            border-radius: 18px;
            overflow: hidden;
            margin: 8px 0 12px;
            box-shadow: 0 8px 28px rgba(15, 23, 42, 0.06);
          }

          .bs-profile-cover {
            position: relative;
            height: 78px;
            background:
              radial-gradient(
                circle at 18% 12%,
                rgba(59, 130, 246, 0.28),
                transparent 34%
              ),
              radial-gradient(
                circle at 86% 14%,
                rgba(14, 165, 233, 0.22),
                transparent 38%
              ),
              linear-gradient(
                135deg,
                #dbeafe,
                #f8fbff
              );
          }

          .bs-profile-body {
            padding: 0 16px 16px;
            margin-top: -42px;
          }

          .bs-avatar-wrap {
            position: relative;
            width: 82px;
            height: 82px;
            margin-bottom: 12px;
          }

          .bs-avatar {
            width: 82px;
            height: 82px;
            border-radius: 50%;
            object-fit: cover;
            background: #e5e7eb;
            border: 4px solid #ffffff;
            box-shadow: 0 8px 20px rgba(15, 23, 42, 0.16);
          }

          .bs-profile-name {
            color: #111827;
            font-size: 18px;
            font-weight: 700;
            margin: 0 0 6px;
          }

          .bs-profile-role {
            color: #334155;
            font-size: 13px;
            margin: 0 0 6px;
            word-break: break-word;
          }

          .bs-profile-location {
            display: flex;
            align-items: center;
            gap: 6px;
            color: #64748b;
            font-size: 12px;
            margin-top: 8px;
          }

          .bs-nav-wrap {
            background: #ffffff;
            border: 1px solid #edf2f7;
            border-radius: 17px;
            padding: 12px;
            margin-bottom: 12px;
            box-shadow: 0 8px 26px rgba(15, 23, 42, 0.045);
          }

          .bs-nav-caption {
            color: #94a3b8;
            font-size: 10px;
            letter-spacing: 0.04em;
            font-weight: 700;
            padding: 2px 4px 10px;
            text-transform: uppercase;
          }

          .bs-nav-list {
            list-style: none;
            padding: 0;
            margin: 0;
          }

          .bs-nav-list li {
            margin-bottom: 4px;
          }

          .bs-nav-link {
            display: grid !important;
            grid-template-columns:
              42px minmax(0, 1fr) 16px !important;
            align-items: center !important;
            column-gap: 10px !important;
            width: 100% !important;
            height: 50px !important;
            padding: 0 12px !important;
            border-radius: 12px !important;
            color: #475569 !important;
            text-decoration: none !important;
            font-size: 14px !important;
            font-weight: 650 !important;
            opacity: 1 !important;
            transition: 0.22s ease !important;
            position: relative !important;
            overflow: hidden !important;
            background: transparent !important;
          }

          .bs-club-link {
            display: grid !important;
            grid-template-columns:
              36px minmax(0, 1fr) 12px !important;
            align-items: center !important;
            column-gap: 8px !important;
            width: 100% !important;
            min-height: 58px !important;
            height: auto !important;
            padding: 8px 8px !important;
            border-radius: 12px !important;
            color: #475569 !important;
            text-decoration: none !important;
            font-size: 14px !important;
            font-weight: 650 !important;
            opacity: 1 !important;
            transition: 0.22s ease !important;
            position: relative !important;
            overflow: hidden !important;
            background: transparent !important;
            cursor: pointer;
          }

          .bs-nav-icon {
            width: 42px !important;
            height: 34px !important;
            min-width: 42px !important;
            display: flex !important;
            align-items: center !important;
            justify-content: flex-start !important;
            flex-shrink: 0 !important;
            background: transparent !important;
            color: #64748b;
            transition: 0.25s ease;
            position: relative;
          }

          .bs-nav-icon i {
            font-size: 20px !important;
            line-height: 1 !important;
            opacity: 1 !important;
            color: inherit !important;
            stroke-width: 2.4px;
            transition: 0.25s ease;
          }

          .bs-nav-icon::after {
            content: "";
            position: absolute;
            left: 8px;
            width: 18px;
            height: 18px;
            border-radius: 50%;
            background: currentColor;
            opacity: 0;
            filter: blur(9px);
            transform: scale(0.7);
            transition: 0.25s ease;
          }

          .bs-nav-text {
            grid-column: 2;
            line-height: 1.2;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            min-width: 0;
            text-align: left;
            justify-self: start;
            max-width: 100%;
          }

          .bs-club-link .bs-nav-text {
            white-space: normal !important;
            overflow: hidden !important;
            text-overflow: unset !important;
            display: -webkit-box !important;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            line-height: 1.25;
            max-width: 100%;
          }

          .bs-feed-icon {
            color: #2563eb;
          }

          .bs-story-icon {
            color: #f59e0b;
          }

          .bs-video-icon {
            color: #ef4444;
          }

          .bs-contact-icon {
            color: #0ea5e9;
          }

          .bs-club-icon {
            color: #10b981;
          }

          .bs-matrimony-icon {
            color: #e11d48;
          }

          .bs-user-icon {
            color: #8b5cf6;
          }

          .bs-form-icon {
            color: #2563eb;
          }

          .bs-map-icon {
            color: #0ea5e9;
          }

          .bs-nav-link:hover,
          .bs-club-link:hover {
            background: #eff6ff !important;
            color: #0f172a !important;
            transform: translateX(2px);
          }

          .bs-nav-link:hover .bs-nav-icon {
            transform: scale(1.1);
          }

          .bs-nav-link:hover .bs-nav-icon::after {
            opacity: 0.16;
            transform: scale(1.2);
          }

          .bs-nav-link:hover .bs-nav-icon i {
            filter: drop-shadow(
              0 5px 8px
              rgba(15, 23, 42, 0.12)
            );
          }

          .bs-nav-arrow {
            grid-column: 3;
            justify-self: end;
            color: #94a3b8 !important;
            font-size: 14px;
            transition: 0.22s ease;
          }

          .bs-nav-link:hover .bs-nav-arrow,
          .bs-club-link:hover .bs-nav-arrow {
            color: #006dff !important;
            transform: translateX(2px);
          }

          .bs-club-logo {
            grid-column: 1;
            width: 32px;
            height: 32px;
            border-radius: 50%;
            object-fit: cover;
            border: 1px solid #e5e7eb;
            justify-self: start;
          }

          .bs-empty-arrow {
            grid-column: 3;
            width: 16px;
            height: 16px;
            display: block;
          }

          .bs-side-navigation
          .bs-nav-wrap
          .bs-nav-list
          > li
          > a.bs-nav-link.active,
          .bs-side-navigation
          .bs-nav-wrap
          .bs-nav-list
          > li
          > a.bs-nav-link.active:hover,
          nav.bs-side-navigation
          a.bs-nav-link.active,
          nav.bs-side-navigation
          a.bs-nav-link.active:hover {
            background: #eff6ff !important;
            background-color: #eff6ff !important;
            background-image: none !important;
            color: #006dff !important;
            box-shadow: none !important;
          }

          .bs-side-navigation
          a.bs-nav-link.active
          .bs-nav-icon,
          .bs-side-navigation
          a.bs-nav-link.active:hover
          .bs-nav-icon {
            color: #006dff !important;
            transform: scale(1.06);
          }

          .bs-side-navigation
          a.bs-nav-link.active
          .bs-nav-text,
          .bs-side-navigation
          a.bs-nav-link.active:hover
          .bs-nav-text {
            color: #006dff !important;
            font-weight: 700 !important;
          }

          .bs-side-navigation
          a.bs-nav-link.active
          .bs-nav-arrow,
          .bs-side-navigation
          a.bs-nav-link.active:hover
          .bs-nav-arrow {
            color: #006dff !important;
          }

          .bs-side-navigation
          a.bs-nav-link.bs-forms-link.active,
          .bs-side-navigation
          a.bs-nav-link.bs-forms-link.active:hover {
            background: #eff6ff !important;
            background-color: #eff6ff !important;
            background-image: none !important;
            color: #006dff !important;
            box-shadow: none !important;
            transform: none !important;
          }

          .bs-side-navigation
          a.bs-nav-link.bs-forms-link.active
          .bs-nav-icon,
          .bs-side-navigation
          a.bs-nav-link.bs-forms-link.active
          .bs-nav-text,
          .bs-side-navigation
          a.bs-nav-link.bs-forms-link.active
          .bs-nav-arrow {
            color: #006dff !important;
          }

          .mobile-nav-menu {
            display: none;
          }

          @media (max-width: 768px) {
            .nav-header,
            .nav-top {
              height: 76px !important;
              min-height: 76px !important;
            }

            .navigation {
              top: 76px !important;
              height: calc(100vh - 76px) !important;
            }

            .main-logo {
              width: 104px;
            }

            .mobile-hide-nav,
            .nav-top .mob-menu,
            .desktop-nav-menu {
              display: none !important;
              visibility: hidden !important;
              width: 0 !important;
              height: 0 !important;
              margin: 0 !important;
              padding: 0 !important;
              overflow: hidden !important;
            }

            .mobile-home-link {
              display: inline-flex !important;
              margin-left: auto !important;
              margin-right: 2px !important;
              width: 46px !important;
              height: 58px !important;
            }

            .mobile-nav-menu {
              display: inline-flex !important;
              position: relative !important;
              flex: 0 0 auto !important;
              width: 42px !important;
              height: 42px !important;
              margin: 0 10px 0 0 !important;
              padding: 0 !important;
              align-items: center !important;
              justify-content: center !important;
              visibility: visible !important;
              overflow: visible !important;
            }

            .nav-header {
              display: flex !important;
              align-items: center !important;
            }

            .nav-top {
              flex: 1 1 auto !important;
              min-width: 0 !important;
              display: flex !important;
              align-items: center !important;
              justify-content: flex-start !important;
              padding-left: 12px !important;
              padding-right: 0 !important;
            }

            .logo-wrapper {
              margin-left: 0 !important;
              margin-right: auto !important;
              justify-content: flex-start !important;
            }

            .main-logo {
              display: block !important;
              margin-left: 0 !important;
            }

            .navigation.nav-active {
              width: 285px !important;
              max-width: 82vw;
              background: #ffffff !important;
              box-shadow:
                10px 0 34px
                rgba(15, 23, 42, 0.12);
            }

            .right-chat,
            .right-chat.active-sidebar,
            .right-scroll-bar,
            .middle-sidebar-right,
            .middle-sidebar-right-content {
              display: none !important;
              visibility: hidden !important;
              opacity: 0 !important;
              width: 0 !important;
              min-width: 0 !important;
              max-width: 0 !important;
              overflow: hidden !important;
            }

            .middle-sidebar-left {
              width: 100% !important;
              max-width: 100% !important;
              flex: 0 0 100% !important;
              padding-right: 0 !important;
            }
          }
        `}
      </style>

      <div className="nav-header bg-white border-0 shadow-none">
        <div className="nav-top">
          <Link
            to="/home"
            className="logo-wrapper"
          >
            <img
              src="/assets/images/bharat_sangam.png"
              alt="Bharat Sangam"
              className="main-logo"
            />
          </Link>

          <Link
            to="/defaultvideo"
            className="mob-menu me-2 mobile-hide-nav"
          >
            <i className="feather-video text-grey-900 font-sm" />
          </Link>

          <button
            type="button"
            onClick={() =>
              toggleState(
                "isOpen"
              )
            }
            className={`nav-menu desktop-nav-menu me-0 ms-2 ${buttonClass}`}
            aria-label="Toggle navigation"
          />
        </div>

        <NavLink
          to="/home"
          className="p-2 text-center ms-3 menu-icon center-menu-icon mobile-home-link"
        >
          <i className="feather-home font-lg" />
        </NavLink>

        <button
          type="button"
          onClick={() =>
            toggleState(
              "isOpen"
            )
          }
          className={`nav-menu mobile-nav-menu ${buttonClass}`}
          aria-label="Toggle mobile navigation"
        />

        <>
          <NavLink
            to="/defaultstorie"
            className="p-2 text-center ms-0 menu-icon center-menu-icon mobile-hide-nav"
          >
            <i className="feather-zap font-lg" />
          </NavLink>

          <NavLink
            to="/defaultvideo"
            className="p-2 text-center ms-0 menu-icon center-menu-icon mobile-hide-nav"
          >
            <i className="feather-video font-lg" />
          </NavLink>

          <NavLink
            to="/contacts"
            className="p-2 text-center ms-0 menu-icon center-menu-icon mobile-hide-nav"
          >
            <i className="feather-user font-lg" />
          </NavLink>

          <NavLink
            to="/clubs-map"
            className="p-2 text-center ms-0 menu-icon center-menu-icon mobile-hide-nav"
          >
            <i className="feather-map-pin font-lg" />
          </NavLink>

          <NavLink
            to="/matrimony/profile"
            className="p-2 text-center ms-0 menu-icon center-menu-icon bs-heart-link mobile-hide-nav"
          >
            <i className="feather-heart font-lg text-danger" />
          </NavLink>

          {isLoggedIn ? (
            <span
              className={`p-2 pointer text-center ms-auto menu-icon ${notiClass}`}
              onClick={() =>
                toggleState(
                  "isNoti"
                )
              }
            />
          ) : (
            <div className="ms-auto" />
          )}
        </>

        <Link
          to={
            isLoggedIn
              ? "/defaultsettings"
              : "/login"
          }
          className="p-0 ms-3 menu-icon top-avatar-link mobile-hide-nav"
        >
          <img
            src={profilePhoto}
            alt="user"
            className="w40 mt--1 rounded-pill"
            onError={(e) => {
              e.currentTarget.src =
                "/assets/images/user.png";
            }}
            style={{
              width: "40px",
              height: "40px",
              objectFit: "cover",
            }}
          />
        </Link>

        <nav
          className={`navigation scroll-bar bs-side-navigation ${navClass}`}
        >
          <div className="container ps-0 pe-0">
            <div className="nav-content">
              <div className="bs-profile-card">
                <div className="bs-profile-cover" />

                <div className="bs-profile-body">
                  <div className="bs-avatar-wrap">
                    <img
                      src={
                        profilePhoto
                      }
                      alt={
                        displayName
                      }
                      className="bs-avatar"
                      onError={(
                        e
                      ) => {
                        e.currentTarget.src =
                          "/assets/images/user.png";
                      }}
                    />
                  </div>

                  <h5 className="bs-profile-name">
                    {displayName}
                  </h5>

                  <p className="bs-profile-role">
                    {profileRole}
                  </p>

                  {selectedClient?.client_name && (
                    <div
                      style={{
                        marginTop:
                          "10px",
                        display:
                          "inline-flex",
                        alignItems:
                          "center",
                        gap: "6px",
                        background:
                          "#eff6ff",
                        color:
                          "#2563eb",
                        padding:
                          "6px 12px",
                        borderRadius:
                          "999px",
                        fontSize:
                          "12px",
                        fontWeight:
                          600,
                      }}
                    >
                      <i className="feather-users" />

                      Inside{" "}
                      {
                        selectedClient.client_name
                      }{" "}
                      Community
                    </div>
                  )}

                  <div className="bs-profile-location">
                    <i className="feather-calendar" />

                    {
                      profileLocation
                    }
                  </div>
                </div>
              </div>

              {linkedClubs.length >
                0 && (
                <div className="bs-nav-wrap">
                  <div className="bs-nav-caption">
                    My Clubs
                  </div>

                  <ul className="bs-nav-list">
                    {linkedClubs.map(
                      (
                        club: any
                      ) => (
                        <li
                          key={
                            club.client_id
                          }
                        >
                          <div
                            className="bs-club-link"
                            onClick={() => {
                              if (
                                club.unique_slug
                              ) {
                                navigate(
                                  `/club/${club.unique_slug}`
                                );

                                closeMobileMenu();
                              }
                            }}
                          >
                            <img
                              src={getUploadUrl(
                                club.logo_image ||
                                  club.client_logo
                              )}
                              alt={
                                club.client_name
                              }
                              className="bs-club-logo"
                              onError={(
                                e
                              ) => {
                                e.currentTarget.src =
                                  "/assets/images/user.png";
                              }}
                            />

                            <span className="bs-nav-text">
                              {
                                club.client_name
                              }
                            </span>

                            <i className="feather-chevron-right bs-nav-arrow" />
                          </div>
                        </li>
                      )
                    )}
                  </ul>
                </div>
              )}

              <div className="bs-nav-wrap">
                <div className="bs-nav-caption">
                  Feed
                </div>

                <ul className="bs-nav-list">
                  <li>
                    <NavLink
                      to="/home"
                      className="bs-nav-link"
                      onClick={
                        closeMobileMenu
                      }
                    >
                      <span className="bs-nav-icon bs-feed-icon">
                        <i className="feather-layout" />
                      </span>

                      <span className="bs-nav-text">
                        Feed
                      </span>

                      <span className="bs-empty-arrow" />
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      to="/defaultstorie"
                      className="bs-nav-link"
                      onClick={
                        closeMobileMenu
                      }
                    >
                      <span className="bs-nav-icon bs-story-icon">
                        <i className="feather-zap" />
                      </span>

                      <span className="bs-nav-text">
                        Posts
                      </span>

                      <i className="feather-chevron-right bs-nav-arrow" />
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      to="/defaultvideo"
                      className="bs-nav-link"
                      onClick={
                        closeMobileMenu
                      }
                    >
                      <span className="bs-nav-icon bs-video-icon">
                        <i className="feather-video" />
                      </span>

                      <span className="bs-nav-text">
                        Videos
                      </span>

                      <i className="feather-chevron-right bs-nav-arrow" />
                    </NavLink>
                  </li>
                </ul>
              </div>

              <div className="bs-nav-wrap">
                <div className="bs-nav-caption">
                  More
                </div>

                <ul className="bs-nav-list">
                  <li>
                    <NavLink
                      to="/contacts"
                      className="bs-nav-link"
                      onClick={
                        closeMobileMenu
                      }
                    >
                      <span className="bs-nav-icon bs-contact-icon">
                        <i className="feather-user" />
                      </span>

                      <span className="bs-nav-text">
                        Address Book
                      </span>

                      <i className="feather-chevron-right bs-nav-arrow" />
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      to="/clubs"
                      className="bs-nav-link"
                      onClick={
                        closeMobileMenu
                      }
                    >
                      <span className="bs-nav-icon bs-club-icon">
                        <i className="feather-users" />
                      </span>

                      <span className="bs-nav-text">
                        Clubs
                      </span>

                      <i className="feather-chevron-right bs-nav-arrow" />
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      to="/matrimony/profile"
                      className="bs-nav-link"
                      onClick={
                        closeMobileMenu
                      }
                    >
                      <span className="bs-nav-icon bs-matrimony-icon">
                        <i className="feather-heart" />
                      </span>

                      <span className="bs-nav-text">
                        Matrimony
                      </span>

                      <i className="feather-chevron-right bs-nav-arrow" />
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      to="/users"
                      className="bs-nav-link"
                      onClick={
                        closeMobileMenu
                      }
                    >
                      <span className="bs-nav-icon bs-user-icon">
                        <i className="feather-users" />
                      </span>

                      <span className="bs-nav-text">
                        Connects
                      </span>

                      <i className="feather-chevron-right bs-nav-arrow" />
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      to="/forms"
                      end
                      className={({
                        isActive,
                      }) =>
                        `bs-nav-link bs-forms-link${
                          isActive
                            ? " active"
                            : ""
                        }`
                      }
                      onClick={
                        closeMobileMenu
                      }
                    >
                      <span className="bs-nav-icon bs-form-icon">
                        <i className="feather-file-text" />
                      </span>

                      <span className="bs-nav-text">
                        Forms
                      </span>

                      <i className="feather-chevron-right bs-nav-arrow" />
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      to="/clubs-map"
                      end
                      className={({
                        isActive,
                      }) =>
                        `bs-nav-link${
                          isActive
                            ? " active"
                            : ""
                        }`
                      }
                      onClick={
                        closeMobileMenu
                      }
                    >
                      <span className="bs-nav-icon bs-map-icon">
                        <i className="feather-map-pin" />
                      </span>

                      <span className="bs-nav-text">
                        Clubs Map
                      </span>

                      <i className="feather-chevron-right bs-nav-arrow" />
                    </NavLink>
                  </li>

                  {!isLoggedIn && (
                    <li>
                      <button
                        type="button"
                        className="bs-nav-link"
                        onClick={() => {
                          closeMobileMenu();
                          navigate(
                            "/login"
                          );
                        }}
                        style={{
                          width:
                            "100%",
                          border:
                            "none",
                          background:
                            "transparent",
                          textAlign:
                            "left",
                          cursor:
                            "pointer",
                        }}
                      >
                        <span className="bs-nav-icon bs-contact-icon">
                          <i className="feather-log-in" />
                        </span>

                        <span className="bs-nav-text">
                          Login
                        </span>

                        <i className="feather-chevron-right bs-nav-arrow" />
                      </button>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </div>

      {showDonate && (
        <DonationModal
          onClose={() =>
            setShowDonate(false)
          }
          clientId={clientId}
          contactId={contactId}
        />
      )}
    </>
  );
};

export default Header;